var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { Component } from 'vue-property-decorator';
import WarningRuleService from '../../api/WarningRuleService';
import GLOBAL_VUE from '../../globalVue';
import AddHeader from './components/AddHeader.vue';
import AddDialog from './components/GoodAdd.vue';
import ArtMsglist from '../../components/alert/ArtMsglist.vue';
var PurchaseList = (function (_super) {
    __extends(PurchaseList, _super);
    function PurchaseList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.data = [];
        _this.formData = {
            organ_id: '',
            depot_id: '',
        };
        _this.selections = [];
        _this.warningTypeOptions = [];
        _this.tableHeight = document.documentElement.clientHeight - 280;
        _this.canSave = true;
        return _this;
    }
    PurchaseList.prototype.created = function () {
        this.service = WarningRuleService.getInstance();
    };
    PurchaseList.prototype.checkSave = function () {
        var flag = true;
        var unsalable_flag = true;
        var regStock = /^(?!(0[0-9]{0,}$))[0-9]{1,}[.]{0,}[0-9]{0,}$/;
        var regDate = /^([1-9][0-9]*)$/;
        this.data.map(function (row) {
            if (row.max_stock && !regStock.test(row.max_stock)) {
                flag = false;
            }
            if (row.safe_stock && !regStock.test(row.safe_stock)) {
                flag = false;
            }
            if (row.unsalable_day && !regDate.test(row.unsalable_day)) {
                unsalable_flag = false;
            }
        });
        if (!flag && !unsalable_flag) {
            this.$message.warning('最大库存与安全库存应为正数，滞销预警天数应为正整数。');
            return false;
        }
        else if (!flag && unsalable_flag) {
            this.$message.warning('最大库存与安全库存应为正数。');
            return false;
        }
        else if (flag && !unsalable_flag) {
            this.$message.warning('滞销预警天数应为正整数。');
            return false;
        }
        return true;
    };
    PurchaseList.prototype.save = function () {
        if (!this.data || !this.data.length) {
            this.$message.warning('请添加货品');
            return;
        }
        if (!this.checkSave())
            return;
        var data = this.data.map(function (item) {
            var obj = {
                goods_id: item.goods_id,
                goods_format_id: item.goods_format_id,
                shelflife_stock_warning_type: item.shelflife_stock_warning_type,
                max_stock: item.max_stock,
                safe_stock: item.safe_stock,
                unsalable_day: item.unsalable_day,
                remark: item.remark,
            };
            return obj;
        });
        var params = __assign({}, this.formData, { data: JSON.stringify(data) });
        this.bindSaveAjax(params);
    };
    PurchaseList.prototype.bindSaveAjax = function (params) {
        var _this = this;
        if (!this.checkSave)
            return;
        this.canSave = false;
        this.service
            .createWarningRule(params)
            .then(function (res) {
            _this.canSave = true;
            if (res.data.code === 53) {
                var instance = _this.$dialog(ArtMsglist, {
                    data: {
                        msgData: res.data.data,
                    },
                }, {
                    title: '提示',
                    width: 450,
                    height: 350,
                }).instance;
                instance.$on('artMsglist:ok', function (data) {
                    var confirm = res.data.data[0].confirm;
                    _this.bindSaveAjax(__assign({}, params, { confirm: confirm }));
                });
                return;
            }
            _this.$message.success(res.data.msg);
            window._czc.push(['_trackEvent', '预警规则添加', '预警规则添加保存']);
            setTimeout(function () {
                GLOBAL_VUE.$emit('closeTab', _this);
                if (_this.opener) {
                    _this.opener.getList();
                }
            }, 500);
        })
            .catch(function (err) {
            _this.$message.error(err.message);
            _this.canSave = true;
        });
    };
    PurchaseList.prototype.toAdd = function () {
        var _this = this;
        var dialog = this.$dialog(AddDialog, {
            data: {
                addedDatas: this.data,
                organ_id: this.formData.organ_id,
                depot_id: this.formData.depot_id,
            },
        }, {
            title: '添加货品',
            width: 900,
            height: 550,
        });
        dialog.instance.$on('submit', function (res) {
            _this.data = res;
            _this.selections = [];
            if (!_this.warningTypeOptions.length)
                _this.getWarningTypeOptions();
            window._czc.push(['_trackEvent', '预警规则添加', '添加货品']);
        });
    };
    PurchaseList.prototype.deleteGood = function () {
        var _this = this;
        if (!this.selections || !this.selections.length) {
            this.$message.warning('请选择货品');
            return;
        }
        this.$confirm('请确认是否删除该货品', '提示').then(function (res) {
            _this.selections.forEach(function (item) {
                var index = _this.data.indexOf(item);
                _this.data.splice(index, 1);
            });
            window._czc.push(['_trackEvent', '预警规则添加', '删除货品']);
        });
    };
    PurchaseList.prototype.emptyGood = function () {
        this.data = [];
    };
    PurchaseList.prototype.getWarningTypeOptions = function () {
        var _this = this;
        this.service.getWarningTypeOptions().then(function (res) {
            if (res.data.success) {
                _this.warningTypeOptions = res.data.data;
            }
        });
    };
    PurchaseList.prototype.getSelectIds = function () {
        var ruleIds = this.selections.map(function (item) { return item.stock_warning_rule_id; });
        return ruleIds.join(',');
    };
    PurchaseList.prototype.checkSelectIds = function () {
        if (!this.selections || !this.selections.length) {
            this.$message.error('请先选择单据！');
            return false;
        }
        else {
            return true;
        }
    };
    PurchaseList.prototype.selectionChange = function (rows) {
        this.selections = rows;
    };
    PurchaseList = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                user: 'user',
            })),
            components: {
                'add-header': AddHeader,
            },
        })
    ], PurchaseList);
    return PurchaseList;
}(Vue));
export default PurchaseList;
